window.addEventListener("load", function () {

    // build all tooltips from data-attributes
    $("[data-toggle='tooltip']").each(function (index, el) {
        $(el).tooltip({
            placement: $(this).data("placement") || 'top'
        });
    });


  // custom uiDropdown element, example can be seen in user-list.html on the 'Filter users' button
    var uiDropdown = new function() {
    var self;
    self = this;
    this.hideDialog = function($el) {
            return $el.find(".dialog").hide().removeClass("is-visible");
    };
    this.showDialog = function($el) {
            return $el.find(".dialog").show().addClass("is-visible");
    };
        return this.initialize = function() {
        $("html").click(function() {
            $(".ui-dropdown .head").removeClass("active");
            return self.hideDialog($(".ui-dropdown"));
            });
            $(".ui-dropdown .body").click(function(e) {
            return e.stopPropagation();
            });
            return $(".ui-dropdown").each(function(index, el) {
            return $(el).click(function(e) {
                e.stopPropagation();
                $(el).find(".head").toggleClass("active");
                if ($(el).find(".head").hasClass("active")) {
                    return self.showDialog($(el));
                } else {
                    return self.hideDialog($(el));
                }
            });
            });
        };
    };

    // instantiate new uiDropdown from above to build the plugins
    new uiDropdown();
});
